export enum SepSessionStorageKeys {
  SEP_IMPERSONATION_SESSION_DATA = 'sepImpersonationSessionData',
}

export interface SepImpersonationSessionData {
  organization: {
    id: string;
    name: string;
    subscriptions: Array<{
      id: string;
      numberOfLicenses: number;
      payment: { paid: boolean; deadline: string | null };
      status:
        | 'active'
        | 'canceled'
        | 'incomplete_expired'
        | 'incomplete'
        | 'past_due'
        | 'paused'
        | 'trialing'
        | 'unpaid';
      freeTrialing: boolean;
      createdAt: string;
      currentPeriodStartedAt: string;
      currentPeriodEndsAt: string;
      isBoundToLearningPlans: boolean;
      externalPriceId: string;
      externalSubscriptionId: string;
    }>;
    tenant: { id: string };
  };
}
